module.exports = __webpack_public_path__ + "img/blue-squares-isomophic-1.0858a396.png";